export default __webpack_public_path__ + "static/media/2.c6e41380.png";